/* Kick Frame — winkelinteracties zonder framework (Shopify-theme) */

(function () {
  'use strict';

  var euro = new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR' });
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function formatCents(cents) {
    return euro.format(Number(cents || 0) / 100);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Gelato-variantnamen ("A2 (42 x 59.4 cm) / Classic ... Framed Poster") naar "A2 · Framed" */
  function shortVariantTitle(title) {
    return String(title || '').split(' / ').map(function (part) {
      if (/Framed|^Eiken$/i.test(part)) return 'Framed';
      if (/Hanger|^Ophangstok$/i.test(part)) return 'With hanger';
      if (/Poster|^Geen$/i.test(part)) return 'Unframed';
      return part.split(' (')[0];
    }).join(' · ');
  }

  /* Producttitels zijn lang voor Google; in de lade alleen de naam */
  function kfName(t) { return String(t || '').replace(/ (Football Poster|Stadium Poster|Voetbalposter|Stadionposter)$/, ''); }

  function sizedImage(url, width) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /* ---------- Ronddraaiende aankondigingsbalk ---------- */

  var announceItems = document.querySelectorAll('.announce li');

  if (announceItems.length > 1) {
    var announceIndex = 0;

    window.setInterval(function () {
      announceItems[announceIndex].classList.remove('is-active');
      announceIndex = (announceIndex + 1) % announceItems.length;
      announceItems[announceIndex].classList.add('is-active');
    }, 3500);
  }

  /* ---------- Header krijgt diepte zodra er gescrold is ---------- */

  var siteHeader = document.querySelector('.site-header');

  if (siteHeader) {
    var updateHeaderElevation = function () {
      siteHeader.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    updateHeaderElevation();
    window.addEventListener('scroll', updateHeaderElevation, { passive: true });
  }

  /* ---------- Mobiel menu ---------- */

  var navToggle = document.querySelector('.nav-toggle');
  var nav = document.getElementById('main-nav');

  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- Toast ---------- */

  var toast = document.querySelector('.toast');
  var toastTimer;

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  /* ---------- Winkelwagen (Shopify Ajax Cart API) ---------- */

  var currentCart = null;
  var cartDrawer = null;

  function cartRequest(path, body) {
    var options = { headers: { Accept: 'application/json' } };
    if (body) {
      options.method = 'POST';
      if (body instanceof FormData) {
        options.body = body;
      } else {
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(body);
      }
    }
    return fetch(root + path, options).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function refreshCart() {
    return cartRequest('cart.js').then(paintCart);
  }

  function paintCart(cart) {
    currentCart = cart;
    var count = cart ? cart.item_count : 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    renderCartDrawer();
    return cart;
  }

  function ensureCartDrawer() {
    if (cartDrawer) return cartDrawer;

    var overlay = document.createElement('div');
    overlay.className = 'cart-overlay';
    overlay.innerHTML =
      '<div class="cart-drawer" role="dialog" aria-modal="true" aria-labelledby="cart-drawer-title">' +
        '<div class="cart-drawer-header">' +
          '<h2 id="cart-drawer-title">Cart</h2>' +
          '<button type="button" class="cart-drawer-close" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="cart-drawer-lines" data-cart-drawer-lines></div>' +
        '<div class="cart-drawer-footer" data-cart-drawer-footer></div>' +
      '</div>';

    document.body.appendChild(overlay);

    function closeDrawer() {
      overlay.classList.remove('is-visible');
    }

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeDrawer();

      var removeButton = event.target.closest('[data-remove-line]');
      if (removeButton) {
        removeButton.disabled = true;
        cartRequest('cart/change.js', { id: removeButton.dataset.removeLine, quantity: 0 }).then(paintCart).catch(function () {
          showToast('Could not remove the item. Please try again.');
          removeButton.disabled = false;
        });
      }
    });

    overlay.querySelector('.cart-drawer-close').addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
    });

    cartDrawer = { overlay: overlay, close: closeDrawer };
    return cartDrawer;
  }

  function renderCartDrawer() {
    if (!cartDrawer) return;

    var linesEl = cartDrawer.overlay.querySelector('[data-cart-drawer-lines]');
    var footerEl = cartDrawer.overlay.querySelector('[data-cart-drawer-footer]');
    var items = (currentCart && currentCart.items) || [];

    if (!items.length) {
      linesEl.innerHTML = '<p class="cart-drawer-empty">Your cart is empty. <a href="' + root + 'collections/all">Choose a poster first</a>.</p>';
      footerEl.innerHTML = '';
      return;
    }

    linesEl.innerHTML = items.map(function (item) {
      var extra = '';
      if (item.properties && item.properties['Eigen ontwerp']) {
        extra = '<div class="cart-line-variant">With your own photo</div>';
      }

      return (
        '<div class="cart-line">' +
          (item.image ? '<img src="' + escapeHtml(sizedImage(item.image, 200)) + '" alt="">' : '<div class="cart-line-thumb"></div>') +
          '<div>' +
            '<div class="cart-line-title">' + escapeHtml(kfName(item.product_title)) + '</div>' +
            '<div class="cart-line-variant">' + escapeHtml(shortVariantTitle(item.variant_title)) + ' &middot; ' + item.quantity + 'x</div>' +
            extra +
            '<div class="cart-line-price">' + formatCents(item.final_line_price) + '</div>' +
          '</div>' +
          '<button type="button" class="cart-line-remove" data-remove-line="' + escapeHtml(item.key) + '">Remove</button>' +
        '</div>'
      );
    }).join('');

    footerEl.innerHTML =
      '<div class="cart-drawer-subtotal"><span>Subtotal</span><span>' + formatCents(currentCart.total_price) + '</span></div>' +
      '<a class="button button--lg button--block" href="' + root + 'checkout">Checkout</a>';
  }

  function openCartDrawer() {
    var drawer = ensureCartDrawer();
    renderCartDrawer();
    drawer.overlay.classList.add('is-visible');
  }

  var cartLink = document.querySelector('[data-cart-toggle]');
  if (cartLink && document.body.className.indexOf('template-cart') === -1) {
    cartLink.addEventListener('click', function (event) {
      event.preventDefault();
      openCartDrawer();
      refreshCart().catch(function () { /* drawer toont laatste bekende stand */ });
    });
  }

  /* ---------- Productconfigurator ---------- */

  var productForm = document.querySelector('[data-product-form]');

  if (productForm) {
    var priceEl = document.querySelector('[data-price]');
    var stickyPriceEl = document.querySelector('[data-sticky-price]');
    var variantInput = productForm.querySelector('[data-variant-id]');
    var submitButtons = productForm.querySelectorAll('button[type="submit"]');
    var jsonEl = document.querySelector('[data-product-json]');
    var variants = [];
    try { variants = JSON.parse(jsonEl ? jsonEl.textContent : '[]'); } catch (err) { variants = []; }

    var selectedVariant = function () {
      var chosen = [];
      productForm.querySelectorAll('input[type="radio"][data-option-position]:checked').forEach(function (input) {
        chosen[Number(input.dataset.optionPosition) - 1] = input.value;
      });
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) { return chosen[index] === undefined || chosen[index] === value; });
      });
    };

    var updateVariant = function () {
      var variant = selectedVariant();
      var available = Boolean(variant && variant.available);

      if (variant) {
        variantInput.value = variant.id;
        var formatted = formatCents(variant.price);
        if (priceEl) priceEl.textContent = formatted;
        if (stickyPriceEl) stickyPriceEl.textContent = formatted;
      }

      submitButtons.forEach(function (btn) {
        btn.disabled = !available;
        btn.textContent = available ? 'Add to cart' : 'Unavailable';
      });
    };

    productForm.addEventListener('change', updateVariant);
    updateVariant();

    var isNativeSubmit = productForm.dataset.nativeSubmit === 'true';

    /* Eigen ontwerp: fotovoorbeeld. De foto zelf gaat mee als bestand in het formulier en wordt door Shopify opgeslagen. */
    var designFile = productForm.querySelector('[data-design-file]');
    if (designFile) {
      var previewWrap = productForm.querySelector('[data-design-preview-wrap]');
      var previewImg = productForm.querySelector('[data-design-preview]');
      var statusEl = productForm.querySelector('[data-design-status]');
      var maxBytes = 20 * 1024 * 1024;

      designFile.addEventListener('change', function () {
        var file = designFile.files && designFile.files[0];
        if (!file) return;

        if (file.size > maxBytes) {
          designFile.value = '';
          previewWrap.hidden = true;
          showToast('File is too large (max 20MB).');
          return;
        }

        previewImg.src = URL.createObjectURL(file);
        previewWrap.hidden = false;
        statusEl.textContent = file.name + ' selected. Your photo will be sent along when you add it to your cart.';
      });
    }

    productForm.addEventListener('submit', function (event) {
      if (designFile && !(designFile.files && designFile.files.length)) {
        event.preventDefault();
        showToast('Please upload a photo before ordering.');
        return;
      }

      /* Met bestand: gewone formulierverzending, Shopify stuurt door naar de winkelwagen. */
      if (isNativeSubmit) {
        submitButtons.forEach(function (btn) { btn.disabled = true; btn.textContent = 'Uploading photo…'; });
        return;
      }

      event.preventDefault();
      submitButtons.forEach(function (btn) { btn.disabled = true; });

      cartRequest('cart/add.js', new FormData(productForm)).then(function () {
        return refreshCart();
      }).then(function () {
        showToast('Added to your cart');
        openCartDrawer();
      }).catch(function (err) {
        showToast((err && err.description) || 'Could not add to cart. Please try again.');
      }).finally(function () {
        updateVariant();
      });
    });
  }

  /* ---------- Galerij ---------- */

  var thumbs = document.querySelectorAll('.thumb');
  var galleryMain = document.querySelector('.gallery-main img');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var img = thumb.querySelector('img');
      if (!galleryMain || !img) return;

      galleryMain.removeAttribute('srcset');
      galleryMain.src = thumb.dataset.full || img.src;

      thumbs.forEach(function (other) {
        other.setAttribute('aria-pressed', String(other === thumb));
      });
    });
  });

  /* ---------- Sticky koopbalk ---------- */

  var stickyBuy = document.querySelector('.sticky-buy');
  var buyAnchor = document.querySelector('[data-buy-anchor]');

  if (stickyBuy && buyAnchor && 'IntersectionObserver' in window) {
    document.body.classList.add('has-sticky-buy');

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBuy.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '-120px 0px 0px 0px' }).observe(buyAnchor);

    stickyBuy.querySelector('button').addEventListener('click', function () {
      if (productForm) productForm.requestSubmit();
    });
  }

  /* ---------- Nieuwsbrief (Klaviyo) ---------- */
  /* Delegated: werkt ook voor de pop-up, die pas ná deze regel aan de DOM wordt toegevoegd. */

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-klaviyo-list]');
    if (!form) return;

    event.preventDefault();

    var emailField = form.querySelector('input[type="email"]');
    var submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + form.dataset.klaviyoCompany, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: emailField.value } } }
          },
          relationships: {
            list: { data: { type: 'list', id: form.dataset.klaviyoList } }
          }
        }
      })
    }).then(function (response) {
      if (response.ok) {
        showToast(form.dataset.klaviyoForm);
        form.reset();
        document.dispatchEvent(new CustomEvent('kf:newsletter-subscribed'));
      } else {
        showToast('Subscribing failed. Please try again.');
      }
    }).catch(function () {
      showToast('Subscribing failed. Please check your internet connection.');
    }).finally(function () {
      if (submitButton) submitButton.disabled = false;
    });
  });

  /* ---------- Kortingspopup ---------- */

  var popupStorageKey = 'kf-popup-seen';
  var popupSeen = true;
  try { popupSeen = Boolean(window.localStorage.getItem(popupStorageKey)); } catch (err) { /* privémodus */ }

  if (!popupSeen && !(window.Shopify && window.Shopify.designMode)) {
    window.setTimeout(function () {
      var overlay = document.createElement('div');
      overlay.className = 'popup-overlay';
      overlay.innerHTML =
        '<div class="popup" role="dialog" aria-modal="true" aria-labelledby="popup-title">' +
          '<button type="button" class="popup-close" aria-label="Close">&times;</button>' +
          '<p class="eyebrow eyebrow--accent">Newsletter</p>' +
          '<h2 id="popup-title">Never miss a new design.</h2>' +
          '<p>Leave your email address and be the first to hear about new designs.</p>' +
          '<form class="newsletter" data-klaviyo-list="Wakke6" data-klaviyo-company="UcTc4g" data-klaviyo-form="Thanks! You\'re subscribed.">' +
            '<label class="visually-hidden" for="popup-email">Email address</label>' +
            '<input id="popup-email" type="email" name="email" placeholder="you@email.com" required autocomplete="email">' +
            '<button class="button" type="submit">Subscribe</button>' +
          '</form>' +
          '<p class="form-note">No spam. Unsubscribe with one click.</p>' +
        '</div>';

      document.body.appendChild(overlay);

      function closePopup() {
        overlay.classList.remove('is-visible');
        try { window.localStorage.setItem(popupStorageKey, '1'); } catch (err) { /* privémodus */ }
        window.setTimeout(function () { overlay.remove(); }, 250);
      }

      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) closePopup();
      });

      overlay.querySelector('.popup-close').addEventListener('click', closePopup);

      document.addEventListener('keydown', function onKeydown(event) {
        if (event.key === 'Escape') {
          closePopup();
          document.removeEventListener('keydown', onKeydown);
        }
      });

      document.addEventListener('kf:newsletter-subscribed', closePopup, { once: true });

      window.requestAnimationFrame(function () {
        overlay.classList.add('is-visible');
        var emailField = overlay.querySelector('input[type="email"]');
        if (emailField) emailField.focus();
      });
    }, 1500);
  }

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Muisvolgende spotlight-gloed over de pagina ---------- */

  if (!reducedMotion && canHover) {
    var cursorGlow = document.createElement('div');
    cursorGlow.className = 'cursor-glow';
    document.body.appendChild(cursorGlow);

    var glowRaf = null;
    var glowX = 0;
    var glowY = 0;

    document.addEventListener('mousemove', function (event) {
      glowX = event.clientX;
      glowY = event.clientY;
      cursorGlow.classList.add('is-active');

      if (glowRaf) return;
      glowRaf = window.requestAnimationFrame(function () {
        cursorGlow.style.transform = 'translate(' + glowX + 'px, ' + glowY + 'px)';
        glowRaf = null;
      });
    });

    document.addEventListener('mouseleave', function () {
      cursorGlow.classList.remove('is-active');
    });
  }

  /* ---------- Muisvolgende 3D-kanteling op uitgelichte posterfoto's ---------- */

  if (!reducedMotion && canHover) {
    document.querySelectorAll('.frame img, .gallery-main img').forEach(function (img) {
      var host = img.closest('.frame') || img.closest('.gallery-main');
      if (!host) return;

      host.addEventListener('mousemove', function (event) {
        // De Cruyff-foto heeft een ingebakken crop-fix (transform: scale) elders in
        // de CSS; die laten we met rust zodra deze specifieke foto in beeld staat.
        if (img.src.indexOf('75a7d995-9974-4694-98de-56efd07b7390') !== -1) return;

        var rect = host.getBoundingClientRect();
        var px = (event.clientX - rect.left) / rect.width;
        var py = (event.clientY - rect.top) / rect.height;
        var rx = (0.5 - py) * 10;
        var ry = (px - 0.5) * 10;

        img.style.transform = 'perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
      });

      host.addEventListener('mouseleave', function () {
        img.style.transform = '';
      });
    });
  }

  /* ---------- Scroll-reveal: secties en kaarten komen in beeld met een zachte lift ---------- */

  if (!reducedMotion && 'IntersectionObserver' in window) {
    var revealSelector = [
      '.usp-grid',
      '.section-head',
      '.product-card',
      '.compare-table-wrap',
      '.split > div',
      '.cols .col',
      '.review',
      '.section--ink .wrap > *',
      '.faq > *'
    ].join(', ');

    var revealTargets = document.querySelectorAll(revealSelector);
    var revealCounts = new WeakMap();

    revealTargets.forEach(function (el) {
      el.classList.add('reveal');
      var parent = el.parentElement;
      var count = revealCounts.get(parent) || 0;
      el.style.transitionDelay = (Math.min(count, 5) * 90) + 'ms';
      revealCounts.set(parent, count + 1);
    });

    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    revealTargets.forEach(function (el) {
      if (el.classList.contains('reveal')) revealObserver.observe(el);
    });
  }
})();
